<script setup lang="ts">
import ModifierGroup from './ModifierGroup.vue';

defineProps<{
  components: any[];
  selectedComponentModifiers: Record<string, Array<string | number>>;
  getComponentGroupKey: (component: any, index: number, groupId: string | number) => string;
  getComponentSelectionCount: (key: string) => number;
  getComponentGroupMaxSelection: (group: any) => number;
  getComponentGroupMinSelection: (group: any) => number;
  formatComponentSelectionCounter: (current: number, group: any) => string;
  getNoSelectionId: (groupId: string | number) => string;
  groupAllowsNoSelection: (group: any) => boolean;
  hasModifierImage: (modifier: any) => boolean;
  getModifierImageSource: (modifier: any) => string;
}>();

const emit = defineEmits<{
  (e: 'toggle', component: any, index: number, group: any, modifierId: string | number, max: number): void;
  (e: 'imageError', event: Event): void;
}>();
</script>

<template>
  <div class="product-detail__components">
    <h4 class="section-title section-title--components">Productos incluidos en el paquete</h4>
    <div
      v-for="(component, componentIndex) in components"
      :key="component.component_item_id || componentIndex"
      class="package-component"
    >
      <div class="package-component__header">
        <div>
          <h5 class="package-component__name">{{ component.quantity }} x {{ component.name }}</h5>
          <p v-if="component.description" class="package-component__desc">{{ component.description }}</p>
        </div>
      </div>

      <ModifierGroup
        v-for="group in (component.modifier_groups || [])"
        :key="`${component.component_item_id}-${group.id}`"
        :group="group"
        :selected-ids="selectedComponentModifiers[getComponentGroupKey(component, componentIndex, group.id)] || []"
        :get-selection-count="() => getComponentSelectionCount(getComponentGroupKey(component, componentIndex, group.id))"
        :get-group-max-selection="getComponentGroupMaxSelection"
        :get-group-min-selection="getComponentGroupMinSelection"
        :format-selection-counter="formatComponentSelectionCounter"
        :group-allows-no-selection="groupAllowsNoSelection"
        :get-no-selection-id="(gid) => `${getNoSelectionId(gid)}${getComponentGroupKey(component, componentIndex, group.id)}`"
        :has-modifier-image="hasModifierImage"
        :get-modifier-image-source="getModifierImageSource"
        @toggle="(_gid, mid, max) => $emit('toggle', component, componentIndex, group, mid, max)"
        @image-error="$emit('imageError', $event)"
      />
    </div>
  </div>
</template>

<style scoped>
.product-detail__components {
  border-top: 1px solid #e2e8f0;
  padding-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.section-title {
  display: block;
  font-weight: 700;
  font-size: 1.1rem;
  color: #0f172a;
}

.package-component {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 0.85rem;
  background: #f8fafc;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.package-component__name {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 800;
  color: #1e293b;
}

.package-component__desc {
  margin: 0.25rem 0 0;
  font-size: 0.82rem;
  color: #475569;
}
</style>
